import React, { useState, useEffect, useRef } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Box from "@mui/material/Box";

// Add imagePath and title as props along with the existing ones
const DialogImage = ({ open, handleClose, imagePath, title }) => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const [imageDimensions, setImageDimensions] = useState({
    width: 0,
    height: 0,
  });
  const imageRef = useRef(null);
  const containerRef = useRef(null);

  // Handle image load to get dimensions
  const handleImageLoad = () => {
    if (imageRef.current) {
      setImageDimensions({
        width: imageRef.current.naturalWidth,
        height: imageRef.current.naturalHeight,
      });
      setImageLoaded(true);
    }
  };

  // Adjust dialog content based on image and viewport
  useEffect(() => {
    const updateDimensions = () => {
      if (imageLoaded && containerRef.current) {
        // We have access to the actual DOM node now
        const container = containerRef.current;
        container.style.maxHeight = "80vh"; // Limit height to 80% of viewport height
        container.style.overflow = "auto"; // Allow scrolling if needed
      }
    };

    if (imageLoaded) {
      updateDimensions();
      window.addEventListener("resize", updateDimensions);
    }

    return () => {
      window.removeEventListener("resize", updateDimensions);
    };
  }, [imageLoaded]);

  return (
    <Dialog
      fullWidth={true}
      maxWidth={"xl"}
      open={open}
      onClose={handleClose}
      PaperProps={{
        sx: {
          width: "auto",
          maxWidth: "95vw", // Limit dialog width to 95% of viewport width
          maxHeight: "95vh", // Limit dialog height to 95% of viewport height
        },
      }}
    >
      <DialogTitle>{title || "Architecture Diagram"}</DialogTitle>
      <DialogContent
        ref={containerRef}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",

          overflow: "hidden", // Hide overflow initially until image is measured
        }}
      >
        <Box
          sx={{
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            ref={imageRef}
            src={imagePath || ""}
            alt={title || "Architecture Diagram"}
            onLoad={handleImageLoad}
            style={{
              maxWidth: "100%",
              maxHeight: "70vh", // Limit image height within dialog
              objectFit: "contain", // Maintain aspect ratio while fitting in container
            }}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogImage;
